import React, { useEffect, useState, useContext } from 'react'
import Router from 'next/router'
import { ProtectedApiProvider } from 'lib/auth0-api'

import {
  auth0Audience,
  auth0Scope,
  auth0Domain,
  auth0ClientId,
  apiUrl,
} from 'env'
import { useAuth0 } from '@auth0/auth0-react'

const onRedirectCallback = appState => {
  Router.replace(appState?.returnTo || '/')
}

const authProps = {
  auth0Domain: auth0Domain,
  auth0ClientId: auth0ClientId,
  audience: auth0Audience,
  redirectUri:
    typeof window !== 'undefined' &&
    new URL('/login', window.location.origin).toString(),
  onRedirectCallback: onRedirectCallback,
  auth0CacheLocation: 'localstorage',
  apiUrl: apiUrl,
  scope: auth0Scope,
}

const Auth0ApiProvider = ({ children }) => {
  return (
    <ProtectedApiProvider {...authProps}>
      <Auth0TokenProvider>{children}</Auth0TokenProvider>
    </ProtectedApiProvider>
  )
}

const Auth0TokenContext = React.createContext()

const Auth0TokenProvider = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0()
  return (
    <Auth0TokenContext.Provider value={{ getToken: getAccessTokenSilently }}>
      {children}
    </Auth0TokenContext.Provider>
  )
}

export const useAuth0Token = () => {
  const [token, setToken] = useState(null)
  const auth0TokenContext = useContext(Auth0TokenContext)
  useEffect(() => {
    if (auth0TokenContext) {
      auth0TokenContext.getToken().then(setToken)
    }
  }, [auth0TokenContext])
  return token
}

export default Auth0ApiProvider
